<script>
  import helpers from '@/helpers';
  import CStatusChip from '@/components/grid/cells/shared/CStatusChip';

  export default {
    extends: CStatusChip,
    computed: {
      status() {
        return helpers.getProjectInfo.projectStatusObjManagers(this, this.params.data?.orderStatus);
      }
    },
  };
</script>
